import {
  Box,
  Container,
  Wrap,
  Text,
} from '@chakra-ui/react';
import { useRef } from 'react';

import MainLayout from '@src/components/layouts/main';
import Pagination from '../../components/Pagination';
import PrintablePdf from '../../components/PrintablePdf';
import TransportProgrammeDeliveryActivityClassExpenditure from './components/report-sections/TransportProgrammeDeliveryActivityClassExpenditure';
import TransportProgrammeDeliveryFunding from './components/report-sections/TransportProgrammeDeliveryFunding';
import TransportProgrammeDeliveryValuation from './components/report-sections/TransportProgrammeDeliveryValuation';
import TransportProgrammeDeliveryReportHeader from './components/report-headers/TransportProgrammeDeliveryReportHeader';
import DataDisclaimer from '../../components/DataDisclaimer';
import TransportProgrammeDeliveryRoadSafety from './components/report-sections/TransportProgrammeDeliveryRoadSafety';
import TransportProgrammeDeliveryWalkingCycling from './components/report-sections/TransportProgrammeDeliveryWalkingCycling';
import TransportProgrammeDeliveryManagement from './components/report-sections/TransportProgrammeDeliveryManagement';
import TransportProgrammeDeliveryCostEfficiencyTotalExpenditure from './components/report-sections/TransportProgrammeDeliveryCostEfficiencyTotalExpenditure';
import TransportProgrammeDeliveryCostEfficiencyMaintenance from './components/report-sections/TransportProgrammeDeliveryCostEfficiencyMaintenance';

function TransportProgrammeDelivery() {
  const printableRef = useRef();

  return (
    <MainLayout backgroundColor="gray.50">
      <Container maxW="full">
        <Pagination
          pdfPrint={(
            <PrintablePdf
              fileName="Transport Programme Delivery"
              printableRef={printableRef}
              printableStyles={null}
            />
          )}
          moreInfo={(
            <>
              <Text mb={4}>
                This page presents a range of transport-related financial activity information for the RCA/network, including breakdowns on Expenditure and Funding.
              </Text>
              <Text>
                The bulk of the results on this page is sourced from TIO via the NZTA Data and Tools web page. This information is supplied to NZTA by RCAs in their Annual Achievement Returns.
              </Text>
            </>
          )}
        />
        <Box ref={printableRef}>
          <TransportProgrammeDeliveryReportHeader />
          <Wrap spacing={2} className="report-sections-wrapper">
            <TransportProgrammeDeliveryActivityClassExpenditure />
            <TransportProgrammeDeliveryFunding />
            <TransportProgrammeDeliveryValuation />
            <TransportProgrammeDeliveryRoadSafety />
            <TransportProgrammeDeliveryWalkingCycling />
            <TransportProgrammeDeliveryManagement />
            <TransportProgrammeDeliveryCostEfficiencyTotalExpenditure />
            <TransportProgrammeDeliveryCostEfficiencyMaintenance />
          </Wrap>
        </Box>
        <DataDisclaimer />
      </Container>
    </MainLayout>
  );
}

export default TransportProgrammeDelivery;
